import { state } from '../core/state.js';
import { saveProgress } from '../progress/xp.js';
import { confetti } from '../ui/confetti.js';
import { SFX, pushPop, toast } from '../ui/toast.js';
import { GAME, gWorld } from './data.js';
import { G, gLevelUp, gQuestProgress, gStats } from './items.js';
import { renderAdventure } from './ui.js';

/* Welten-Länge: Welt w hat baseLen + (w-1)*growLen Räume (letzter Raum = Boss), gedeckelt bei maxLen.
   → je höher die Welt, desto mehr Lernhindernisse bis zum Boss. */
export function worldLen(w) { const e = GAME.exam; return Math.min(e.maxLen, e.baseLen + (w - 1) * e.growLen); }
export function worldStart(w) { let s = 1; for (let i = 1; i < w; i++) s += worldLen(i); return s; }   // erster Abschnitt der Welt
/* Zu welcher Welt gehört ein Abschnitt? + ist es der Boss-Raum? */
export function sectionWorld(s) {
  let w = 1, start = 1;
  while (start + worldLen(w) - 1 < s) { start += worldLen(w); w++; }
  const len = worldLen(w); const idx = s - start + 1;
  return { world: w, start, len, idx, isExam: idx === len };
}
export function gSectionMeta(s) {
  const si = sectionWorld(s);
  const isExam = si.isExam;
  let hp = GAME.obstacle.hp * Math.pow(GAME.obstacle.hpG, s);
  if (isExam) hp *= GAME.exam.hpMult;
  const w = si.world;
  const tier = (w - 1) % 3;                          // für Styling (Boss-Klasse etc.)
  const World = gWorld(w);                            // jede Welt = eigene Gegnergruppe + Hintergrund
  if (isExam) {
    return { isExam, hp: Math.round(hp), tier, world: w, name: World.boss.name, enemy: World.boss.img, bg: World.bg };
  }
  const foe = World.enemies[(si.idx - 1) % World.enemies.length];   // nur die 3 Gegner DIESER Welt
  return { isExam, hp: Math.round(hp), tier, world: w, name: foe.name, enemy: foe.img, bg: World.bg };
}
export function gEnsureObstacle() {
  const g = G();
  if (g.obstacle && g.obstacle.hp > 0) { if (!g.obstacle.sprites) gMigrateObstacleSprites(g.obstacle); return; }
  const m = gSectionMeta(g.section);
  const World = gWorld(sectionWorld(g.section).world);
  const pick = () => World.enemies[Math.floor(Math.random() * World.enemies.length)];
  let hp = m.hp, name = m.name, rewardMult = 1, count = 1, elite = false, nSide = 0;
  let sprites = [{ img: m.enemy, name: m.name, boss: m.isExam }];
  if (m.isExam) {
    // Boss + evtl. 1–2 Handlanger aus derselben Welt
    nSide = Math.random() < 0.45 ? (Math.random() < 0.35 ? 2 : 1) : 0;
    for (let i = 0; i < nSide; i++) { const e = pick(); sprites.push({ img: e.img, name: e.name, boss: false }); }
    if (nSide) { hp = Math.round(hp * (1 + 0.18 * nSide)); rewardMult = 1 + 0.4 * nSide; name = m.name + ' & ' + nSide + ' Handlanger'; }
  } else {
    // Selten: eine Gegnergruppe (gleich oder gemischt)
    const roll = Math.random();
    if (roll < 0.14) {
      count = roll < 0.03 ? 3 : 2;
      const same = Math.random() < 0.5; const base = pick();
      sprites = Array.from({ length: count }, () => { const e = same ? base : pick(); return { img: e.img, name: e.name, boss: false }; });
      hp = Math.round(m.hp * count * 0.85); rewardMult = count;
      name = same ? `${count}× ${base.name}` : 'Gruppe: ' + [...new Set(sprites.map((s) => s.name))].slice(0, 2).join(' & ');
    } else if (Math.random() < 0.06) {
      // Sehr selten: gold-schimmernder Champion – mehr HP, garantierte Truhe
      elite = true; hp = Math.round(m.hp * 1.8); rewardMult = 2.2; name = '✨ Champion-' + m.name;
    }
  }
  const shield = m.isExam ? Math.min(6, 2 + Math.floor(sectionWorld(g.section).world / 2)) : 0;
  g.obstacle = { name, hp, maxHp: hp, isExam: m.isExam, tier: m.tier, shield, shieldMax: shield, sprites, count, rewardMult, elite, nSide };
}
/* Alt-Spielstand: Hindernis ohne sprites-Feld nachrüsten. */
export function gMigrateObstacleSprites(ob) {
  const m = gSectionMeta(G().section);
  ob.sprites = [{ img: m.enemy, name: ob.name, boss: !!ob.isExam }];
  ob.count = ob.count || 1; ob.rewardMult = ob.rewardMult || 1;
}
export function gCardHit(rating, tookMs, wasDue, isNew) {
  const g = G(); if (!g.on) return null;
  gEnsureObstacle();
  const st = gStats();
  const combo = state.session?.combo || 0;
  const factor = (isNew || wasDue) ? 1 : 0.35;
  let mult = GAME.ratingDmg[rating] || 1;
  const fast = (rating === 'good' || rating === 'easy') && tookMs < GAME.fastMs;
  if (fast) mult *= GAME.fastBonus;
  // Fokus voll (Spezialangriff): Effekt hängt vom gewählten Fokus-Spezial ab
  const fokus = (g.focusEnergy || 0) >= GAME.fokusMax && rating !== 'again';
  const special = gFokusSpecial();
  const fokusMult = fokus ? (FOKUS_SPECIALS[special].mult || 2) : 1;
  // Krit-Rausch: garantierte Geistesblitze für die nächsten Karten
  const critForced = !fokus && (g.critStreak || 0) > 0 && rating !== 'again';
  let crit = fokus || critForced || rating === 'easy' || (Math.random() * 100 < st.crit);
  if (critForced) g.critStreak = Math.max(0, (g.critStreak || 0) - 1);
  const comboBonus = 1 + combo * (g.up.combo || 0) * GAME.up.combo.per;   // Combo-Kraft-Upgrade
  let dmg = Math.max(1, Math.round(st.knowledge * mult * (crit ? GAME.critMult : 1) * factor * comboBonus * fokusMult));
  // Boss-Schild: absorbiert die ersten Treffer (stark reduzierter Schaden), bis er bricht.
  let shieldHit = false, shieldBroke = false;
  if (g.obstacle.isExam && (g.obstacle.shield || 0) > 0) {
    g.obstacle.shield -= 1; shieldHit = true; if (g.obstacle.shield <= 0) shieldBroke = true;
    dmg = Math.max(1, Math.round(dmg * 0.25));
  }
  g.obstacle.hp -= dmg;
  let goldRush = 0;
  if (fokus) {
    if (special === 'krit') g.critStreak = 3;
    else if (special === 'gold') { goldRush = Math.max(30, Math.round(st.coinsPerMin * 25)); state.progress.coins += goldRush; }
    else if (special === 'kette' && g.obstacle.hp < 0) g.carryDmg = Math.round(-g.obstacle.hp); // Überschuss → nächstes Hindernis
  }
  g.charXp += Math.round((isNew ? 15 : wasDue ? 10 : 4) * factor);
  // Tages-/Wochenziele
  gQuestProgress('cards');
  if (rating === 'good' || rating === 'easy') gQuestProgress('good');
  if (rating === 'easy') gQuestProgress('easy');
  if (crit) gQuestProgress('crit');
  if (fokus) gQuestProgress('fokus');
  // Fokus-Meter: füllt sich mit guten Antworten; voll → verbraucht (Spezialangriff)
  if (fokus) g.focusEnergy = 0;
  else g.focusEnergy = (g.focusEnergy || 0) + (rating === 'good' || rating === 'easy' ? 3 : rating === 'hard' ? 1 : 0);
  // Truhen-Fortschritt (deutlich schneller + Truhenglück-Upgrade)
  const fortune = g.up.fortune || 0;
  g.chestProgress = (g.chestProgress || 0) + Math.round(GAME.chestPerCard * (factor >= 1 ? 1 : 0.4) * (1 + fortune * 0.15));
  let meterChest = false;
  if (g.chestProgress >= 100) { g.chestProgress -= 100; g.chests += 1; meterChest = true; }
  const levelUps = gLevelUp();
  let out = { dmg, crit, fokus, rating, defeated: false, meterChest, levelUps, special: fokus ? special : null, goldRush, shieldHit, shieldBroke, shield: g.obstacle ? g.obstacle.shield : 0 };
  if (g.obstacle.hp <= 0) out = { ...out, ...gDefeatObstacle(), defeated: true };
  g.lastStudy = Date.now();
  return out;
}
export function gDefeatObstacle() {
  const g = G(); const st = gStats(); const ob = g.obstacle;
  const worldNum = sectionWorld(g.section).world;   // Welt des besiegten Hindernisses (vor dem Vorrücken)
  const reward = Math.round(GAME.obstacle.reward * Math.pow(GAME.obstacle.rewardG, g.section) * (ob.isExam ? GAME.exam.rewardMult : 1) * (ob.rewardMult || 1) * st.collect * (1 + st.coinBonus));
  state.progress.coins += reward;
  g.sessionDefeats = (g.sessionDefeats || 0) + 1;
  gQuestProgress('defeat', (ob.count && ob.count > 1) ? ob.count : 1);   // Gruppe zählt als mehrere Siege
  // Statistik für Erfolge
  if (ob.count >= 3) g.groupsBeaten = (g.groupsBeaten || 0) + 1;
  if (ob.isExam && (ob.nSide || 0) >= 2) g.bossSquadBeaten = (g.bossSquadBeaten || 0) + 1;
  if (ob.elite) g.elitesBeaten = (g.elitesBeaten || 0) + 1;
  let chest = false, gems = 0;
  if (ob.isExam) { chest = true; g.chests += 1; gems = 1; state.progress.gems += 1; g.examsBeaten = (g.examsBeaten || 0) + 1; gQuestProgress('exam'); }
  else if (ob.elite) { chest = true; g.chests += 1; }   // Champion: garantierte Truhe
  else if (Math.random() < GAME.chestDrop + st.luck * 0.03 + (g.up.fortune || 0) * 0.03 + (ob.count > 1 ? 0.12 : 0)) { chest = true; g.chests += 1; }
  g.section += 1; g.maxSection = Math.max(g.maxSection, g.section);
  g.obstacle = null; gEnsureObstacle();
  // Kettenschlag: übertragener Schaden trifft direkt das neue Hindernis
  let carried = 0;
  if (g.carryDmg > 0) { carried = g.carryDmg; g.obstacle.hp = Math.max(1, g.obstacle.hp - carried); g.carryDmg = 0; }
  return { reward, chest, exam: ob.isExam, gems, carried,
    worldCleared: ob.isExam ? worldNum : 0, worldName: ob.isExam ? gWorld(worldNum).name : '', nextWorldName: ob.isExam ? gWorld(worldNum + 1).name : '' };
}
export function gUpgradeCost(key) { const u = GAME.up[key]; return Math.round(u.base * Math.pow(u.growth, G().up[key])); }
/* Fokus-Spezialangriffe – Wirkung beim vollen Fokus-Meter (mult in gCardHit). */
export const FOKUS_SPECIALS = {
  power: { name: 'Wuchtschlag',  icon: '💥', mult: 2.0, desc: 'Fokus-Treffer macht doppelten Schaden.' },
  kette: { name: 'Kettenschlag', icon: '⛓️', mult: 1.7, desc: 'x1,7 Schaden – der Überschuss trifft sofort das nächste Hindernis.' },
  gold:  { name: 'Goldrausch',   icon: '🪙', mult: 1.5, desc: 'x1,5 Schaden und ein Regen aus Wissensmünzen.' },
  krit:  { name: 'Krit-Rausch',  icon: '🌟', mult: 1.6, desc: 'x1,6 Schaden – die nächsten 3 Karten sind garantierte Geistesblitze.' },
};
/* ── Talentbaum: jede Lernstufe gibt 1 Skillpunkt; Knoten kosten Punkte und schalten
   dauerhaft frei (mehrere Äste gleichzeitig). Fokus-Knoten werden als aktiver Angriff wählbar. ── */
export const SKILL_TREE = [
  { id: 'root', name: 'Wuchtschlag',      icon: '💥', cost: 0, req: null, pos: [50, 9],  fokus: 'power',              desc: 'Grund-Fokus: doppelter Schaden. Immer verfügbar.' },
  { id: 'a1',   name: 'Scharfer Verstand', icon: '📖', cost: 1, req: 'root', pos: [17, 33], stat: 'knowledge', val: 0.05, desc: '+5 % Angriffskraft.' },
  { id: 'a2',   name: 'Tiefes Wissen',     icon: '📚', cost: 2, req: 'a1',   pos: [17, 60], stat: 'knowledge', val: 0.10, desc: '+10 % Angriffskraft.' },
  { id: 'a3',   name: 'Kettenschlag',      icon: '⛓️', cost: 2, req: 'a2',   pos: [17, 87], fokus: 'kette',              desc: 'Fokus: Überschuss trifft das nächste Hindernis.' },
  { id: 'c1',   name: 'Wache Augen',       icon: '👁️', cost: 1, req: 'root', pos: [50, 39], stat: 'crit', val: 4,       desc: '+4 % Geistesblitz.' },
  { id: 'c2',   name: 'Blitzgeist',        icon: '⚡', cost: 2, req: 'c1',   pos: [50, 64], stat: 'crit', val: 8,       desc: '+8 % Geistesblitz.' },
  { id: 'c3',   name: 'Krit-Rausch',       icon: '🌟', cost: 2, req: 'c2',   pos: [50, 89], fokus: 'krit',               desc: 'Fokus: nächste 3 Karten garantierte Geistesblitze.' },
  { id: 'b1',   name: 'Glückspfote',       icon: '🍀', cost: 1, req: 'root', pos: [83, 33], stat: 'luck', val: 2,       desc: '+2 Truhen-Glück.' },
  { id: 'b2',   name: 'Goldader',          icon: '💰', cost: 2, req: 'b1',   pos: [83, 60], stat: 'coin', val: 0.10,    desc: '+10 % Wissensmünzen.' },
  { id: 'b3',   name: 'Goldrausch',        icon: '🪙', cost: 2, req: 'b2',   pos: [83, 87], fokus: 'gold',               desc: 'Fokus: x1,5 Schaden + Münzregen.' },
];
export const SKILL_BY_ID = Object.fromEntries(SKILL_TREE.map((n) => [n.id, n]));
export function gSkillUnlocked(id) { return id === 'root' || !!(G().skillNodes && G().skillNodes[id]); }
export function gSkillSpent() { return SKILL_TREE.reduce((s, n) => s + (n.id !== 'root' && gSkillUnlocked(n.id) ? n.cost : 0), 0); }
export function gSkillPoints() { return Math.max(0, (G().charLvl || 1) - gSkillSpent()); }   // 1 Punkt pro Lernstufe
export function gSkillCanUnlock(n) { return !gSkillUnlocked(n.id) && (n.req === null || gSkillUnlocked(n.req)) && gSkillPoints() >= n.cost; }
export function gSpecialUnlocked(sp) { if (sp === 'power') return true; const n = SKILL_TREE.find((x) => x.fokus === sp); return !!(n && gSkillUnlocked(n.id)); }
export function gFokusSpecial() { const k = G().fokusSpecial; return (FOKUS_SPECIALS[k] && gSpecialUnlocked(k)) ? k : 'power'; }
export function gSetActiveSpecial(k) {
  if (!FOKUS_SPECIALS[k] || !gSpecialUnlocked(k)) { toast('Diesen Fokus-Angriff erst im Talentbaum freischalten'); return; }
  G().fokusSpecial = k; try { SFX.good(); } catch (e) {}
  saveProgress(); renderAdventure();
}
export function gSkillNodeClick(id) {
  const n = SKILL_BY_ID[id]; if (!n) return;
  if (gSkillUnlocked(id)) { if (n.fokus) gSetActiveSpecial(n.fokus); return; }   // schon frei → Fokus aktivieren
  if (!(n.req === null || gSkillUnlocked(n.req))) { toast('Erst den vorherigen Knoten freischalten'); return; }
  if (gSkillPoints() < n.cost) { toast(`Nicht genug Skillpunkte – du brauchst ${n.cost} (steig weitere Lernstufen auf).`); return; }
  G().skillNodes[id] = true; try { SFX.win(); } catch (e) {} confetti();
  if (n.fokus) G().fokusSpecial = n.fokus;   // frisch freigeschalteten Fokus direkt aktiv
  pushPop({ img: 'assets/icon_star.png', eyebrow: 'Talent freigeschaltet!', name: n.name, reward: n.desc });
  saveProgress(); renderAdventure();
}
